module.exports = __webpack_public_path__ + "media/play_event_moose-add.59632636.mp3";